import { SearchProps } from '~components/form-fields/search';

import { selectLookupFundingTypes } from '~support-at-home/selectors/fundingTypes';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields: SearchProps = {
  client_name: {
    persist: true,
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname'],
    placeholder: 'Client Name',
    caption: 'Client Name',
    hidden: isEncryptionEnabled,
  },
  created_at: {
    persist: true,
    defaultShow: true,
    type: 'date-range',
    field: 'created_at',
    caption: 'Reconciliation',
  },
  claim_created_at: {
    defaultShow: false,
    type: 'date-range',
    field: 'claim.created_at',
    caption: 'Claim',
  },
  funding_source_ids: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'funding_source_ids',
    caption: 'Funding Type',
    selectorOptions: selectLookupFundingTypes,
  },
};
